import NullableArrayType from './NullableArray';

export default {
  ...NullableArrayType,
  default() {
    return [];
  },
};



// WEBPACK FOOTER //
// ./mixins/Form/Types/Array.js